import { Component } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Router, RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { GlobalService } from './services/global.service';
import { environment } from 'environments/environment';
import { AuthService } from './services/auth.service';

@Component({
    selector: 'app-root',
    template: `
        <block-ui message="Carregando dados" [delayStart]="500" [delayStop]="500">
            <router-outlet (activate)="scrollTop($event)"></router-outlet> 
        </block-ui>
    `,
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    @BlockUI() blockUI: NgBlockUI;

    constructor(
        private router: Router,
        private global: GlobalService,
        private authService: AuthService
    ) {

        this.router.events.subscribe((event: RouterEvent) => {
            this.navigationInterceptor(event)
        })

        if (environment.production) {
            window.console.log = function () { };
        }

    }

    public getQueryParams(route) {
        let uri = route.split("?");
        if (uri.length == 1) {
            return null;
        }
        else {
            let result: any = {}
            uri = uri[1];
            uri = uri.split("&");
            for (let params of uri) {
                let paramIdx = params.indexOf("=");
                let key = params.substring(0, paramIdx);
                let value = params.substring(paramIdx + 1);
                result[key] = decodeURIComponent(value);
            }
            return result;
        }
    }

    public navigationInterceptor(event: RouterEvent): void {

        if (event instanceof NavigationStart) {
            this.blockUI.start('Carregando...');
            if (!this.global.loggedUser()) {
                this.global.params = this.getQueryParams(event.url);
            }
        }

        if (event instanceof NavigationEnd) {
            this.blockUI.stop()
        }

        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof NavigationCancel) {
            this.blockUI.stop()
        }

        if (event instanceof NavigationError) {
            this.blockUI.stop()
        }
    }

    public scrollTop(event) {
        window.scroll(0, 0);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts